import request from '@/utils/request'
import { AxiosPromise } from 'axios'

export function getAdmissionTicketInfo (id: number): AxiosPromise {
    return request({
        url: `/hd-api/os/app/school-exam-plan/examination-info/${id}`,
        method: 'get',
    })
}